import { render, staticRenderFns } from "./TableForm6.vue?vue&type=template&id=307a0d70&scoped=true"
import script from "./TableForm6.vue?vue&type=script&lang=ts"
export * from "./TableForm6.vue?vue&type=script&lang=ts"
import style0 from "./TableForm6.vue?vue&type=style&index=0&id=307a0d70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307a0d70",
  null
  
)

export default component.exports